import { JiraExport } from '../models/JiraExport';

export class JiraExportMapper {
  mapGQLModel(data: any) {
    return new JiraExport(
      data.url,
      data.jiraConsumerKey,
      data.jiraPublicKey,
      data.jiraProjectKey,
      data.jiraIssuetypeKey,
      data.jiraAuthorizationUrl,
      data.jiraAccessToken
    );
  }
}
